import React, { useEffect, useState } from "react"
import { AssetMap } from "../types"

interface NavProps {
  modal: boolean
  backPath: string
  assets: AssetMap
  showRoundDetails()
  shouldShowPlayers: boolean
  showPlayers()
  showFAQ()
  showHelp()
}

export default function Nav({
  modal,
  backPath,
  assets,
  showRoundDetails,
  shouldShowPlayers,
  showPlayers,
  showFAQ,
  showHelp
}: NavProps) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (visible) {
      document.body.classList.add(`overflow-menu--open`)
    } else {
      document.body.classList.remove(`overflow-menu--open`)
    }
  }, [visible])

  return (
    <div className="app-nav">
      <div className="nav-container">
        {modal ? (
          <>
            <div className="modal-page">
              <div className="close-icon">
                <a
                  onClick={(e) => {
                    e.preventDefault()
                    showRoundDetails()
                  }}
                >
                  <img src={assets.close} alt="close" />
                </a>
              </div>
              <OverflowMenu
                visible={visible}
                setVisible={setVisible}
                assets={assets}
                shouldShowPlayers={shouldShowPlayers}
                showPlayers={showPlayers}
                showFAQ={showFAQ}
                showHelp={showHelp}
              />
            </div>
          </>
        ) : (
          <>
            <div className="sub-page">
              <div className="back-icon">
                <a href={backPath} id="back-arrow">
                  <img src={assets.arrowLeft} alt="back" />
                </a>
              </div>
              <OverflowMenu
                visible={visible}
                setVisible={setVisible}
                shouldShowPlayers={shouldShowPlayers}
                showPlayers={showPlayers}
                showFAQ={showFAQ}
                showHelp={showHelp}
                assets={assets}
              />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

interface OverflowMenuProps {
  visible: boolean
  setVisible: (boolean) => void
  assets: AssetMap
  shouldShowPlayers: boolean
  showPlayers()
  showFAQ()
  showHelp()
}

function OverflowMenu({
  visible,
  setVisible,
  assets,
  shouldShowPlayers,
  showPlayers,
  showFAQ,
  showHelp
}: OverflowMenuProps) {
  return (
    <>
      <div className="overflow-menu-icon">
        <a onClick={() => setVisible(!visible)}>
          <img src={assets.overflow} alt="overflow menu" style={{ width: 20 }} />
        </a>
      </div>
      <div id="overflow-menu" className={`modal modal--bottom-sheet-mobile ${visible ? "show" : ""}`}>
        <div className="modal-wrapper">
          <div className="modal-main">
            <div className="container">
              <ul className="list-group list-group--action-sheet-list">
                {shouldShowPlayers ? (
                  <li>
                    <a
                      onClick={() => {
                        showPlayers()
                        setVisible(false)
                      }}
                    >
                      Manage players
                    </a>
                  </li>
                ) : (
                  <></>
                )}
                <li>
                  <a
                    onClick={() => {
                      showFAQ()
                      setVisible(false)
                    }}
                  >
                    FAQs
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      showHelp()
                      setVisible(false)
                    }}
                  >
                    Help
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="modal-mask" onClick={() => setVisible(!visible)} />
      </div>
    </>
  )
}
